import { Text } from "@chakra-ui/react";
import React from "react";

const CFormLabels = ({ label }) => {
  return <Text>{label}</Text>;
};
export default CFormLabels;
